// extracted by mini-css-extract-plugin
export var borderRadius = "_9t-4";
export var large = "_9t-3";
export var logoContainer = "_9t-0";
export var nameLogo = "_9t-2";
export var small = "_9t-1";